import React, { useState } from 'react';
import { Input, Button, Modal, Spin, Table, Empty } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import './styles.scss';
import { fetchSearch } from 'containers/Reports/reports.action';

const { Search } = Input;

// const fetchQuestions = async (searchTerm) => {
//   console.log('searchTerm', searchTerm);
//   const data = [
//     {
//       name: 2024,
//       studyId: [
//         {
//           name: 'infy',
//           id: 20,
//           questions: [
//             {
//               qId: 'D1',
//               qText: 'What is your Gender',
//               options: ['Male', 'Female']
//             },
//             {
//               qId: 'D2',
//               qText: 'What is your Age',
//               options: ['18-25', '26-35', '36-45', '45+']
//             }
//           ]
//         },
//         {
//           name: 'wipro',
//           id: 20,
//           questions: [
//             {
//               qId: 'D1',
//               qText: 'What is your Gender',
//               options: ['Male', 'Female']
//             },
//             {
//               qId: 'D2',
//               qText: 'What is your Age',
//               options: ['18-25', '26-35', '36-45', '45+']
//             }
//           ]
//         }
//       ]
//     },
//     {
//       name: 2023,
//       studyId: [
//         {
//           name: 'wipro',
//           id: 20,
//           questions: [
//             {
//               qId: 'D3',
//               qText: 'What is your Gender 2',
//               options: ['Male', 'Female']
//             },
//             {
//               qId: 'D4',
//               qText: 'What is your Occupation',
//               options: ['Engineer', 'Doctor', 'Teacher', 'Others']
//             }
//           ]
//         }
//       ]
//     }
//   ];
//   return data;
// };

const SearchQues = ({ updateSearchData }) => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState('');

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const resultdata = useSelector((state) => state.reports);

  const { searchData, searchLoading } = resultdata;

  const handleSearchChange = (val) => {
    setSearchTerm(val.target.value);
    if (searchTerm.length < 1) {
      return;
    }
  };

  const handleSearchClick = async (val) => {
    setErrorMessage('');
    if (val.length < 1) {
      setErrorMessage('');
      return;
    }
    if (val.length < 3) {
      setErrorMessage('Search term must be 3+ characters.');
      return;
    }

    dispatch(fetchSearch(searchTerm));

    setIsModalVisible(true);
  };

  const handleCancelModal = () => {
    setIsModalVisible(false);
  };

  const handleSelectQuestion = (question) => {
    updateSearchData(question);
    setIsModalVisible(false);
  };

  return (
    <div className="searchwrapper">
      <div className="searchbox">
        <div>
          <span className="label" style={{ opacity: 0, visibility: 'hidden' }}>
            Search question
          </span>
          <Search
            placeholder="input search text"
            allowClear
            defaultValue={searchTerm}
            onChange={handleSearchChange}
            onSearch={handleSearchClick}
            enterButton
            style={{ width: '100%' }}
          />
          {errorMessage && (
            <p style={{ color: 'red', margin: 0, fontWeight: 'normal' }}>{errorMessage}</p>
          )}
        </div>
      </div>

      <Modal
        title="Question Details"
        open={isModalVisible}
        onCancel={handleCancelModal}
        footer={null}
        width={800}
      >
        <div>
          <div>
            <Search
              placeholder="input search text"
              allowClear
              defaultValue={searchTerm}
              onChange={handleSearchChange}
              onSearch={handleSearchClick}
              style={{ width: 500 }}
            />
            <p style={{ color: 'red', margin: 0, fontWeight: 'normal' }}>{errorMessage}</p>
          </div>
          {searchLoading ? (
            <div className="loadingctrl">
              <Spin size="large" />
            </div>
          ) : searchData.length > 0 ? (
            searchData?.map((study, yearindex) => (
              <div key={`${study.name}_${yearindex}`} className="searchmdlctrl">
                <h4>{study.name}</h4>

                {study.studyId.map((studyItem, index) => (
                  <div key={`${studyItem.id}_${index}`}>
                    <h5>{studyItem.name}</h5>
                    <Table
                      rowKey="qId"
                      size="small"
                      dataSource={studyItem.questions.map((question) => ({
                        ...question,
                        studyName: studyItem.name,
                        studyId: studyItem.id,
                        year: study.name
                      }))}
                      pagination={false}
                      columns={[
                        {
                          title: 'Question',
                          dataIndex: 'qText',
                          key: 'qText',
                          render: (text, record) => {
                            return (
                              <>
                                {text}
                                <br />
                                {<small>{record.options.join(', ')}</small>}
                              </>
                            );
                          }
                        },

                        {
                          title: 'Action',
                          key: 'action',
                          width: 150,
                          align: 'center',
                          render: (text, record) => (
                            <Button
                              type="primary"
                              size="small"
                              onClick={() => handleSelectQuestion(record)}
                            >
                              Select
                            </Button>
                          )
                        }
                      ]}
                    />
                  </div>
                ))}
              </div>
            ))
          ) : (
            <Empty style={{ padding: 15 }} />
          )}
        </div>
      </Modal>
    </div>
  );
};

export default SearchQues;
